module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k9LaO"))).then(() => parcelRequire('d0iPb'));